import React from "react";
import { connect } from "react-redux";
import { Grid, Header } from "semantic-ui-react";
import BlueButton from "components/Buttons/BlueButton";

const styles = {
	blocWhite: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
		overflowY: "auto",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
		color: "white",
	},
};

const Issue = () => {
	const refreshCache = async (e) => {
		e?.preventDefault();
		window.location.reload(true);
	};

	return (
		<Grid textAlign="left" style={{ height: "100vh" }} verticalAlign="top">
			<Grid.Column style={{ maxWidth: 950, padding: 40, height: "93vh" }}>
				<Header as="h2" color="teal" textAlign="center" style={{ backgroundColor: "rgb(0, 147, 128)" }} />
				<div style={styles.blocHeader}>
					<h3>Vous rencontrez un problème ?</h3>
				</div>
				<div style={styles.blocWhite}>
					<span>
						Contactez-nous directement par email à <a href="mailto:helpdesk.mylabnurse@bionext.lu">helpdesk.mylabnurse@bionext.lu</a>
					</span>
					<br />
					<BlueButton onClick={refreshCache} text="Vider le cache" style={{ margin: "20px 0 0" }} />
				</div>
			</Grid.Column>
		</Grid>
	);
};

export default Issue;
